import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdminSidebar from './AdminSidebar';
import { adminBaseStyles } from '../../../theme/style';


class AdminLayout extends Component {
  render() {
    const layoutStyle = Object.assign({}, adminBaseStyles.layout)
    return (
      <div>
        <div style={layoutStyle}>
          <AdminSidebar {...this.props} />
          <section style={adminBaseStyles.alignment}>
            {this.props.children}
          </section>
        </div>
      </div>
    );
  }
}

AdminLayout.defaultProps = {
  layoutStyle: {},
}

AdminLayout.propTypes = {
  layoutStyle: PropTypes.object,
}

export default AdminLayout;
